export default __webpack_public_path__ + "static/media/mail-list.a0ee951b.svg";